/** Footage tab — the three knobs that make captions readable over real
 *  video. Darken is a black layer UNDER the captions; brightness and
 *  contrast light the footage itself (1 = untouched). */
import type { StudioInspectorProps } from "../../StudioInspector.tsx";
import { SliderRow } from "../essentials/index.ts";

export function FootageTab({ inspector }: { inspector: StudioInspectorProps }): React.JSX.Element {
  const { layout, onPreview, onCommit } = inspector;
  const video = layout.video;
  return (
    <>
      <SliderRow
        label="Darken" value={video.dim} min={0} max={0.8} step={0.02}
        toPatch={(v) => ({ layout: { video: { dim: v } } })} commitLabel="Darken"
        onPreview={onPreview} onCommit={onCommit}
      />
      <SliderRow
        label="Brightness" value={video.brightness} min={0.5} max={1.6} step={0.05}
        toPatch={(v) => ({ layout: { video: { brightness: v } } })} commitLabel="Brightness"
        onPreview={onPreview} onCommit={onCommit}
      />
      <SliderRow
        label="Contrast" value={video.contrast} min={0.6} max={1.5} step={0.05}
        toPatch={(v) => ({ layout: { video: { contrast: v } } })} commitLabel="Contrast"
        onPreview={onPreview} onCommit={onCommit}
      />
    </>
  );
}
